export default __webpack_public_path__ + "static/media/texasstarsLG.45b27715.png";